export enum ArnConnectorType {
  /**
   * A custom Arianee implementation for Wallet Connect.
   *
   * Displays a QR code which allows being redirected to the app store
   * (through a deeplink) if the user doesn't have the app.
   */
  LegacyWC = 'LegacyWC',

  /**
   * Supports several web3 providers, including Wallet Connect, MetaMask, etc.
   */
  Web3Modal = 'Web3Modal',

  /**
   * Supports several web3 providers, including Wallet Connect, MetaMask, etc. (v2)
   */
  Web3ModalV2 = 'Web3ModalV2',

  /**
   * Arianee Access Token.
   *
   * @see ArnToken
   */
  AAT = 'AAT',
}
